import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Layers } from "lucide-react";
import UniversCommerciauxTab from "@features/creation/univers-commerciaux/components/UniversCommerciauxTab";

export const Route = createFileRoute('/_app/creation/univers-commerciaux/')({
  loader: requirePermission(PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.VIEW),
  staticData: {
    title: "Univers Commerciaux",
    icon: Layers,
    permission: PERMISSIONS.CREATION.UNIVERS_COMMERCIAUX.VIEW,
    module: "creation",
    section: "Creation",
    order: 24,
    description: "Gestion des univers commerciaux",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: UniversCommerciauxTab,
});